import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import blockingModal from '@blockcatio/tabby-library/lib/utilities/blockingModal';
import { walletDefinitions } from '@blockcatio/tabby-library/lib/utilities/walletTypes';
import WalletSelectionContainer from '@blockcatio/tabby-library/lib/components/wallet/WalletSelectionContainer';
import InvalidContractNetworkModal from '@blockcatio/tabby-library/lib/components/wallet/InvalidContractNetworkModal';
import AddressNotReadableModal from '@blockcatio/tabby-library/lib/components/wallet/AddressNotReadableModal';
import NoBrowserWalletModal from '@blockcatio/tabby-library/lib/components/wallet/NoBrowserWalletModal';

import LoadingScreenModal from './LoadingScreenModal';
import IntroModal from './IntroModal';
import TermsOfServiceModal from './TermsOfServiceModal';

const AccountWrapper = ({
  detectedNetwork,
  expectedNetwork,
  children,
  isLoading,
  isLocked,
  isMissingWeb3,
  isNotProvided,
  tosAccepted,
  onTosAccept,
  onTosReject,
  introCompleted,
  onIntroComplete,
  walletType,
  onWalletSelect,
  onWalletReset,
  wrongNetwork,
  onAccountRefresh,
  givenProvider,
  isWalletReloading,
  onWalletIsSupported,
}) => {
  let modal = null;
  if (!introCompleted) {
    modal = blockingModal(<IntroModal onSubmit={onIntroComplete} />);
  } else if (isWalletReloading) {
    modal = blockingModal(<LoadingScreenModal />);
  } else if (!walletType) {
    modal = blockingModal(<WalletSelectionContainer
      walletDefinitions={walletDefinitions}
      onWalletSelect={onWalletSelect}
      givenProvider={givenProvider}
      onWalletIsSupported={onWalletIsSupported}
    />);
  } else if (wrongNetwork) {
    modal = blockingModal(
      <InvalidContractNetworkModal
        contractNetworkName={expectedNetwork}
        networkName={detectedNetwork}
        onBack={onWalletReset}
        appName="Tabby Pay"
      />,
      'warning',
    );
  } else if (isMissingWeb3) {
    modal = blockingModal(<NoBrowserWalletModal onBack={onWalletReset} />, 'warning');
  } else if (isLocked || isNotProvided) {
    modal = blockingModal(
      <AddressNotReadableModal
        walletType={walletType}
        onRetry={onAccountRefresh}
        onBack={onWalletReset}
      />,
      'warning',
    );
  } else if (isLoading) {
    modal = blockingModal(<LoadingScreenModal />);
  } else if (!tosAccepted) {
    modal = blockingModal(<TermsOfServiceModal onSubmit={onTosAccept} onCancel={onTosReject} />);
  }

  return (
    <div>
      {modal}
      {children}
    </div>
  );
};

AccountWrapper.defaultProps = {
  isLocked: false,
  isNotProvided: false,
  onTosReject: noop,
  givenProvider: null,
  isWalletReloading: false,
};

AccountWrapper.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool,
  isNotProvided: PropTypes.bool,
  wrongNetwork: PropTypes.bool.isRequired,
  isMissingWeb3: PropTypes.bool.isRequired,
  walletType: PropTypes.string.isRequired,
  onWalletSelect: PropTypes.func.isRequired,
  onWalletReset: PropTypes.func.isRequired,
  detectedNetwork: PropTypes.string.isRequired,
  expectedNetwork: PropTypes.string.isRequired,
  tosAccepted: PropTypes.bool.isRequired,
  onTosAccept: PropTypes.func.isRequired,
  onTosReject: PropTypes.func,
  introCompleted: PropTypes.bool.isRequired,
  onIntroComplete: PropTypes.func.isRequired,
  onAccountRefresh: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  givenProvider: PropTypes.shape({}),
  isWalletReloading: PropTypes.bool,
  onWalletIsSupported: PropTypes.func.isRequired,
};

export default AccountWrapper;



// WEBPACK FOOTER //
// ./src/components/AccountWrapper.js